/**
 * Вход в админку.
 *
 * Отдельной формы регистрации нет: роль moderator или admin выдаёт
 * администратор существующему пользователю, самостоятельно её получить нельзя.
 */
import { useLogin } from "@refinedev/core";
import { Button, Card, Form, Input, Layout, Typography } from "antd";

interface LoginValues {
  email: string;
  password: string;
}

export function LoginPage() {
  const { mutate: login, isPending } = useLogin<LoginValues>();

  return (
    <Layout
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(ellipse at top, rgba(217,148,71,0.12), transparent 55%), #0c0d11",
      }}
    >
      <Card style={{ width: 400, maxWidth: "92vw" }}>
        <Typography.Title level={3} style={{ marginBottom: 4, display: "flex", alignItems: "center", gap: 10 }}>
          <img src={`${import.meta.env.BASE_URL}logo-mark.svg`} width={32} height={32} alt="" />
          ChronoGuessr
        </Typography.Title>
        <Typography.Paragraph type="secondary">
          Панель модерации. Вход по учётной записи с ролью модератора или администратора.
        </Typography.Paragraph>

        <Form<LoginValues> layout="vertical" onFinish={(values) => login(values)}>
          <Form.Item
            label="Email или имя пользователя"
            name="email"
            rules={[{ required: true, message: "Укажите логин" }]}
          >
            <Input autoComplete="username" placeholder="admin@chronoguessr.io" />
          </Form.Item>

          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: "Введите пароль" }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>

          <Button type="primary" htmlType="submit" block loading={isPending}>
            Войти
          </Button>
        </Form>
      </Card>
    </Layout>
  );
}
